var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button as AntButton } from 'antd';
import { twMerge } from 'tailwind-merge';
// import { ButtonProps } from 'antd/lib/button' // Optional, for types
function ButtonAnt(_a) {
    var onClick = _a.onClick, buttonText = _a.buttonText, isDisabled = _a.isDisabled, widthFull = _a.widthFull, className = _a.className, _b = _a.htmlType, htmlType = _b === void 0 ? 'submit' : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, props = __rest(_a, ["onClick", "buttonText", "isDisabled", "widthFull", "className", "htmlType", "loading"]);
    var disabled = isDisabled || loading;
    // Styling logic inherited from Button.tsx
    // Notes:
    // - Using !important via tailwind (e.g. !) or relying on cascade might be needed if Ant styles conflict,
    //   but we will trust the existing class names to do the heavy lifting.
    // - We apply 'w-full' to className, but Ant also supports 'block' property. We use both for safety.
    var computedClasses = disabled
        ? (widthFull && 'w-full') + " \n             border-none bg-transparent text-gray-400 font-semibold rounded-lg " + className
        : (widthFull && 'w-full') + " \n             border-none hover:shadow-custom-btn hover:text-btn-text-hover text-white font-semibold rounded-lg " + className;
    return (_jsx(AntButton, __assign({ onClick: onClick, disabled: disabled, loading: loading, block: widthFull, htmlType: htmlType, className: twMerge(computedClasses) }, props, { children: buttonText }), void 0));
}
ButtonAnt.defaultProps = {
    isDisabled: false,
    onClick: function () { },
    widthFull: false,
    loading: false,
    htmlType: 'submit',
    type: 'primary'
};
export default ButtonAnt;
